
import {defineComponent} from "vue";
import EntityIndex from "./EntityIndex.vue";
import ShowVideos from "@/components/home/ShowVideos.vue";
import MicroSite from "@/views/MicroSite.vue";
import GeneralStatistics from "@/views/GeneralStatistics.vue";
import {
  carouselService,
  microSiteService,
  statisticsService,
  videoService,
} from "@/services";
import {PagedAsyncIterDriver} from "@/pagination";
import {VideoWithMainPagePosition} from "@/services/video-service";
import Carousel from "@/views/Carousel.vue";
import CarouselType from "@/entities/carousel";
import MicroSites from "@/entities/micro-sites";
import Statistics from "@/entities/statistics";

export default defineComponent({
  components: {
    MicroSite,
    EntityIndex,
    ShowVideos,
    Carousel,
    GeneralStatistics,
  },
  data() {
    return {
      showSocialMedia: false,
      videos: [] as VideoWithMainPagePosition[],
      images: [] as CarouselType[],
      microSites: [] as MicroSites[],
      statistics: {} as Statistics
    };
  },
  computed: {
    facebookAdaptWidth(): boolean {
      return window.innerWidth < 768;
    },
    videosAreAvailable() {
      if (this.videos.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    carouselItemsAreAvailable() {
      if (this.images.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    microSitesAreAvailable() {
      if (this.microSites.length > 0) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    remToPixel(rem: number) {
      return (
          rem * parseFloat(getComputedStyle(document.documentElement).fontSize)
      );
    },
    socialsChildWidth() {
      const vnode = this.$refs.socialMediaBlock as HTMLDivElement;
      if (window.innerWidth >= 768) {
        return vnode.offsetWidth / 2;
      }
      return vnode.offsetWidth - this.remToPixel(2);
    },
    reMountSocialMediaScripts() {
      setTimeout(() => {
        //eslint-disable-next-line  @typescript-eslint/no-explicit-any
        (window as any).twttr?.widgets.load();

        //eslint-disable-next-line  @typescript-eslint/no-explicit-any
        (window as any).FB?.XFBML.parse();
      }, 250);
    },
    async getMainPageVideos() {
      const iter = videoService.getMainPageVideos();
      this.videos = await new PagedAsyncIterDriver(iter).fetchRemaining();
    },
    async getCarrouselItems() {
      try {
        this.images = await new PagedAsyncIterDriver(
            carouselService.listCarousels({active: 1})
        ).fetchRemaining();
      } catch (e) {
        console.log(e);
      }
    },
    async getMicroSitesItems() {
      try {
        this.microSites = await new PagedAsyncIterDriver(
            microSiteService.listMicroSites()
        ).fetchRemaining();
      } catch (e) {
        console.log(e);
      }
    },
    moreVideos() {
      this.$router.push({name: "public-videos"});
    },
    async getGeneralStatistics() {
      try {
        this.statistics = await statisticsService.getGeneralStatistics();
      } catch (e) {
        console.log(e);
      }
    },
  },
  watch: {
    // mainVideo(newVal) {
    //   this.mainVideo = newVal;
    // },
  },
  async mounted() {
    await this.getCarrouselItems();
    await this.getMicroSitesItems();
    this.reMountSocialMediaScripts();
    this.showSocialMedia = true;
    await this.getMainPageVideos();
    await this.getGeneralStatistics()
  },
  beforeRouteUpdate() {
    this.reMountSocialMediaScripts();
  },
});
